import React, { memo, forwardRef } from "react";
const SvgFraction = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M8.75 16.058h14.5"
      />
      <rect width={8} height={10} x={12} y={3} fill="#DBDBDB" rx={1} />
      <rect width={8} height={10} x={12} y={19} fill="#DBDBDB" rx={1} />
    </svg>
  );
});
SvgFraction.displayName = "SvgFraction";
const MemoForwardRef = memo(SvgFraction);
export default MemoForwardRef;
